// 04/11/2026 (registre n° 39) : échanges client sur une demande.
// Service Demandes reçues (même domaine : /__recues/api/fil…, comptes ADMIN), jeton de la personne connectée.
const BASE = "/__recues/api/";

const entetes = () => {
  let t = null;
  try { t = window.localStorage.getItem("token"); } catch (e) { /* stockage indisponible */ }
  return t ? { Authorization: "Bearer " + t } : {};
};

const reponse = (r) =>
  r.json().catch(() => ({})).then((j) => {
    if (!r.ok) throw new Error(j.erreur || "erreur " + r.status);
    return j;
  });

const post = (url) =>
  fetch(BASE + url, { method: "POST", headers: entetes(), cache: "no-store" }).then(reponse);

export const lienFil = (id) => post("fil/" + encodeURIComponent(id) + "/lien");
export const lireFil = (id) => fetch(BASE + "fil/" + encodeURIComponent(id), { headers: entetes(), cache: "no-store" }).then(reponse);
export const marquerLu = (id) => post("fil/" + encodeURIComponent(id) + "/lu").then((j) => { rafraichirEtats(); return j; });

// ---- états pour les pastilles de la liste : {id: "reponse" | "attente"}, partagés par toutes les lignes
let etats = {};
let charge = 0;
let enCours = null;
const abonnes = new Set();

const publier = () => abonnes.forEach((f) => { try { f(etats); } catch (e) { /* ligne démontée */ } });

const charger = () => {
  if (enCours) return enCours;
  enCours = fetch(BASE + "fil-etats", { headers: entetes(), cache: "no-store" })
    .then(reponse)
    .then((j) => { etats = j || {}; charge = Date.now(); publier(); })
    .catch(() => { charge = Date.now(); /* service indisponible : pas de pastille */ })
    .then(() => { enCours = null; });
  return enCours;
};

export const rafraichirEtats = () => { charge = 0; setTimeout(charger, 800); };

export const abonnerEtats = (f) => {
  abonnes.add(f);
  if (Date.now() - charge > 60000) charger();
  else f(etats);
  return () => abonnes.delete(f);
};



// WEBPACK FOOTER //
// ./src/store/external/fil.js